import React, { Dispatch, SetStateAction } from 'react';
import { Modal, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';
import { translate } from '../../../services/translate';
import FormActions from '../../../components/FormActions';
import { WindowInformation } from '../../../services/window-information';
import { parseTextWithBold } from '../DeacCommons';
import FileFormatDropdown from '../../../components/FileFormatDropdown';

interface ModalProps {
    isModalVisible: boolean;
    setIsModalVisible: Dispatch<SetStateAction<boolean>>;
    onConfirm: () => void;
    fileExtension: 'pdf' | 'csv' | 'xlsx' | '';
    setFileExtension: Dispatch<SetStateAction<'pdf' | 'csv' | 'xlsx' | ''>>;
}

export default function ExportAgentsSchedulesSelectModal({ isModalVisible, setIsModalVisible, onConfirm, fileExtension, setFileExtension }: ModalProps) {
    const { styles } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    const closeModal = () => {
        setFileExtension('');
        setIsModalVisible(false);
    };

    return (
        <Modal
            transparent
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={() => closeModal()}
        >
            <View style={styles.container}>
                <View style={styles.formContainer(windowInfo.isMobile)}>
                    <View style={{ flexDirection: 'column', gap: 8 }}>
                        <MyAppText style={styles.header}>{translate('exportAgentsScheduleTitle')}</MyAppText>
                        <MyAppText style={styles.subheader}>{parseTextWithBold(translate('exportAgentsScheduleSelectMessage'))}</MyAppText>
                    </View>

                    <FileFormatDropdown
                        value={fileExtension}
                        setValue={setFileExtension}
                        zIndex={1}
                        labelStyle={styles.fieldsLabelStyle}
                        viewStyle={{ gap: 8 }}
                        includesXlsx={false}
                    />

                    <FormActions
                        viewStyle={{ flex: 1, justifyContent: 'space-around' }}
                        buttonStyle={{ paddingHorizontal: 16, paddingVertical: 9, }}
                        buttonContentContainerStyle={{ flex: 1 }}
                        cancelText='goBack'
                        confirmText='export'
                        onSubmit={onConfirm}
                        onClose={closeModal}
                        disabled={fileExtension === ''}
                    />
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1,
        paddingHorizontal: 16,
    },
    formContainer: (isMobile: boolean) => ({
        width: isMobile ? '95%' : 450,
        backgroundColor: theme.colors.container.background,
        borderRadius: 4,
        paddingHorizontal: 16,
        paddingVertical: 24,
        rowGap: 32,
    }),
    header: {
        fontSize: 18,
        fontWeight: '700',
        flexWrap: 'wrap',
        color: theme.colors.modal.header,
    },
    subheader: {
        fontSize: 16,
        fontWeight: '400',
        flexWrap: 'wrap',
        color: theme.colors.modal.subheader,
    },
    fieldsLabelStyle: {
        color: theme.colors.neutral['500'],
        fontWeight: '600',
        fontSize: 14,
    },
}));
